import { Injectable } from "@angular/core";
import { lastValueFrom } from "rxjs";
import { apiCallWrapper } from "../../api/api.util";
import { ReportingJobApi } from "../../api/reporting/reporting-job.api";
import { ReportLevelEnum } from "../../model/reporting/contract/reporting-contract";
import { BaseService } from "../base.service";
import { ToastService } from "../toast.service";

@Injectable({
  providedIn: "root",
})
/**
 * @description This service is used to manage ReportingJob API.
 */
export class ReportingJobService extends BaseService {
  constructor(
    private toastService: ToastService,
    private reportingJobApi: ReportingJobApi,
  ) {
    super();
  }

  public async create(
    documentId: number,
    formGroupInstanceId: number,
    reportLevel: ReportLevelEnum,
    contactExternalId?: string,
  ): Promise<boolean> {
    try {
      const data = await lastValueFrom(
        apiCallWrapper(
          this.reportingJobApi.createReportJob({
            documentId,
            formGroupInstanceId,
            reportLevel,
            contactExternalId,
          }),
          {
            toastService: this.toastService,
            action: "Creating ReportJob",
          },
        ),
      );

      if (data && data.success) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      throw error;
    }
  }

  public async getReportAccess(token: string): Promise<{ success: boolean; message: string }> {
    const data = await lastValueFrom(
      apiCallWrapper(this.reportingJobApi.getReportAccess(token), {
        toastService: this.toastService,
        action: "Retrieving Report Access",
      }),
    );

    return data;
  }
}
